import React from 'react';
import styled from '@emotion/styled';
import { Css, VisuallyHidden } from '../../../../../ui';
import { Color } from '../../../../shared/styles/Color';
import { IYoutubeCollection } from '../../../domain/models/IYoutubeCollection';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import Responsive from '../../../../../ui/utils/Responsive';

export interface IYoutubeCollectionProps {
	youtubeVideoCollection: IYoutubeCollection | null;
}

export const YoutubeCollection = ({
	youtubeVideoCollection,
}: IYoutubeCollectionProps) => {
	const { t } = useTranslation();

	return (
		<StyledYouTubeCollection>
			<StyledVideoCardWrapper>
				{youtubeVideoCollection?.videos.map((video) => (
					<StyledVideoCard
						key={video.videoId}
						href={`https://www.youtube.com/watch?v=${video.videoId}`}
						target="_blank"
						rel="noopener noreferrer"
					>
						<img
							src={`https://img.youtube.com/vi/${video.videoId}/maxresdefault.jpg`}
							alt={t('social_media_youtube_video_alt', { title: video.title })}
						/>
						<StyledVideoTitle>{video.title}</StyledVideoTitle>
						<VisuallyHidden as="span">
							{t('generic_external_link_label')}
						</VisuallyHidden>
					</StyledVideoCard>
				))}
			</StyledVideoCardWrapper>
		</StyledYouTubeCollection>
	);
};

const StyledYouTubeCollection = styled.div`
	max-height: 539px; // Same as Facebook iFrame
	overflow-y: hidden;
	padding-top: 24px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		height: 100%;
		max-height: none;
	}
`;

export const StyledVideoCardWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: 16px;
	justify-items: center;
	height: 100%;
`;

export const StyledVideoCard = styled.a`
	display: flex;
	justify-content: top;

	flex-direction: column;
	width: 100%;
	margin-bottom: ${Css.pxToRem(24)};
	color: ${Color.TextBlack};
	cursor: pointer;

	transition: transform 0.2s ease-in-out;

	&:hover {
		text-decoration: none;
		transform: translateY(-6px);
	}

	img {
		border-radius: 8px;
		width: 100%;
		object-fit: cover;
	}
`;

export const StyledVideoTitle = styled.p`
	font-size: ${Css.pxToRem(16)};
	line-height: ${Css.pxToRem(19)};
	font-weight: 500;
	margin-top: ${Css.pxToRem(8)};
`;
